<style lang="scss" scoped>
  .p-colorOverlay {
    position: relative;
    overflow: hidden;
    transform-origin: 0 50%;
    transform: scaleX(0);
    will-change: transform;

    // &[data-scale] {
    //   img {
    //     transform: scale(1.05);
    //     transition: transform 3s linear;
    //   }

    //   &.is-animated {
    //     img {
    //       transform: scale(1);
    //     }
    //   }
    // }
  }

  .p-colorOverlay__layer {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transform-origin: 100% 50%;
    will-change: transform;
  }


</style>

<template>
  <div 
    class="p-colorOverlay" 
    :class="{
      'is-animated': isAnimated
    }"
    :data-scale="scale">
    <slot></slot>
    <div class="p-colorOverlay__layer" ref="layer"></div>
  </div>
</template>

<script>
  import { TimelineMax } from "gsap"
  import 'rgbaster'

  export default {
    props: {
      offset: {
        type: Number,
        default: () => {
          return 0.67
        }
      },
      scale: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        timeline: null,
        image: null,
        layer: null,
        unwatch: null,
        isAnimated: false,
      }
    },
    watch: {
    },
    created() {
      // eslint-disable-next-line no-new
      this.timeline = new TimelineMax()
      this.unwatch = this.$watch('$window.scrollY', this.onScroll)
    },
    mounted() {
      this.image = this.$el.querySelector('img')
      this.layer = this.$refs.layer

      let backgroundColor = '#2e3a3e'

      if(this.image) {
        global.RGBaster.colors(this.image, {
          exclude: [
            'rgb(255,255,255)',
            'rgb(0,0,0)',
          ],
          success: (payload) => {
            backgroundColor = payload.dominant
            this.layer.style.backgroundColor = backgroundColor

            if(this.offset < 0) {
              this.animate()
            }
          }
        })  
      } else {
        this.layer.style.backgroundColor = backgroundColor
      }
    },
    beforeDestroy() {
      this.unwatch && this.unwatch()
    },
    methods: {
      animate() {
        this.unwatch()

        this.isAnimated = true

        this.timeline.to(this.$el, 1.2, {
          ease: Power4.easeInOut,
          scaleX: 1,
          onComplete: () => {
            this.$el.style.willChange = 'auto'
          }
        }).to(this.layer, 1.2, {
          delay: -0.8,
          ease: Power4.easeInOut,
          scaleX: 0,
          onComplete: () => {
            this.layer.style.willChange = 'auto'
          }
        })
      },
      onScroll() {
        if(this.$el.getBoundingClientRect().top <= this.$window.height * this.offset) {
          this.animate()
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/plugins/color-overlay/component.vue